module.exports = __webpack_public_path__ + "img/training-orderbeheer.4168f903.png";